<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">ECカテゴリ変換マスタ一覧出力</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">対象</label>
          <div class="list-input-content radio-group">
            <!-- 対象から "商品マスタ" を外すためコメントアウト -->
            <!-- <app-radio-label id="rdb_GoodsCategory" #rdb_GoodsCategory [subid]="'rdb_GoodsCategory'"
              [(ngModel)]="kymw6802Model.radioGroup" name="grp_CategoryDiv" value="1" label="商品マスタ"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-radio-label> -->
            <app-radio-label id="rdb_PlanCategory" #rdb_PlanCategory [subid]="'rdb_PlanCategory'"
              [(ngModel)]="kymw6802Model.radioGroup" name="grp_CategoryDiv" value="2" label="商品企画マスタ"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-radio-label>
            <app-radio-label id="rdb_StockLimitFlg" #rdb_StockLimitFlg [subid]="'rdb_StockLimitFlg'"
              [(ngModel)]="kymw6802Model.radioGroup" name="grp_CategoryDiv" value="3" label="在庫限定"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-radio-label>
          </div>

          <label class="list-input-title">変換区分</label>
          <div class="list-input-content">
            <app-kymw68-conv-div-combo-box id="cmb_ConvDiv" #cmb_ConvDiv [subid]="'cmb_ConvDiv'"
              [(ngModel)]="kymw6802Model.convDiv" [blank]="true" [autofocus]="true" [style.width.%]="100"
              [categoryDiv]="kymw6802Model.radioGroup" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-kymw68-conv-div-combo-box>
          </div>

          <label class="list-input-title">カテゴリ</label>
          <div class="list-input-content">
            <input type="text" id="txti_CategoryCode" #txti_CategoryCode [(ngModel)]="kymw6802Model.categoryCode"
              plessInputTextSub [maxlength]="9" [restrict]="'[0-9]'" forcedEnabledMode="true" [tabindex]="0">
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content">
            <app-class-code-combo-box id="cmb_ClassCode" #cmb_ClassCode [subid]="'cmb_ClassCode'" [blank]="true"
              [initFocusItem]="cmb_ConvDiv" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-class-code-combo-box>
          </div>

          <label class="list-input-title">大分類</label>
          <div class="list-input-content">
            <app-large-class-code-combo-box id="cmb_LargeClassCode" #cmb_LargeClassCode [subid]="'cmb_LargeClassCode'"
              [blank]="true" [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-large-class-code-combo-box>
          </div>

          <label class="list-input-title">中分類</label>
          <div class="list-input-content">
            <app-middle-class-code-combo-box id="cmb_MiddleClassCode" #cmb_MiddleClassCode
              [subid]="'cmb_MiddleClassCode'" [blank]="true" [classCodeComboBoxFlg]="true"
              [classCode]="cmb_ClassCode.selectedClassCode" [largeClassCodeComboBoxFlg]="true"
              [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-middle-class-code-combo-box>
          </div>

          <label class="list-input-title">小分類</label>
          <div class="list-input-content">
            <app-small-class-code-combo-box id="cmb_SmallClassCode" #cmb_SmallClassCode [subid]="'cmb_SmallClassCode'"
              [blank]="true" [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode"
              [largeClassCodeComboBoxFlg]="true" [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode"
              [middleClassCode]="cmb_MiddleClassCode.selectedMiddleClassCode" [forcedEnabledMode]="'true'"
              [tabindex]="0">
            </app-small-class-code-combo-box>
          </div>

          <label class="list-input-title">マーク</label>
          <div class="list-input-content">
            <app-mark-code-text-input id="txti_MarkCode" #txti_MarkCode [subid]="'txti_MarkCode'"
              [(ngModel)]="kymw6802Model.markCode" [maxlength]="3" [restrict]="'[0-9]'" [forcedEnabledMode]="'true'"
              [tabindex]="0">
            </app-mark-code-text-input>
          </div>

          <label class="list-input-title">価格パターン</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_PricePattern" #cmb_PricePattern [subid]="'cmb_PricePattern'"
              [(ngModel)]="kymw6802Model.pricePattern" [initFocusItem]="cmb_ConvDiv" [forcedEnabledMode]="'true'"
              [labelField]="'codeValueName'" [codeDiv]="'ct355'" [tabindex]="0">
            </app-code-combo-box>
          </div>

          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-plan-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'"
              [(ngModel)]="kymw6802Model.mediumType" [initFocusItem]="cmb_ConvDiv" [forcedEnabledMode]="'true'"
              [tabindex]="0" style="width: 100%;" (change)="eventMedium_CHANGEHandler()">
            </app-plan-medium-type-combo-box>
          </div>

          <label class="list-input-title">特集</label>
          <div class="list-input-content">
            <app-kymw68-feature-code-combo-box id="cmb_FeatureCode" #cmb_FeatureCode [subid]="'cmb_FeatureCode'" [width]="344"
              [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw6802Model.featureCode" [mediumType]="kymw6802Model.mediumType"
              [initAutoLoad]="false">
            </app-kymw68-feature-code-combo-box>
          </div>

          <label class="list-input-title">ページ</label>
          <div class="list-input-content">
            <input type="text" id="txti_PageNum" #txti_PageNum [(ngModel)]="kymw6802Model.pageNum" plessInputTextSub
              [maxlength]="3" [restrict]="'[0-9]'" forcedEnabledMode="true" [tabindex]="0">
          </div>

          <label class="list-input-title">プロモーション区分</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_ProDiv" #cmb_ProDiv [subid]="'cmb_ProDiv'" [(ngModel)]="kymw6802Model.proDiv"
              [codeDiv]="'ct350'" [initFocusItem]="cmb_ConvDiv" (change)="eventProDiv_CHANGEHandler()"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-code-combo-box>
          </div>

          <label class="list-input-title">プロモーション情報</label>
          <div class="list-input-content">
            <app-promotion-code-combo-box id="cmb_ProInfo" #cmb_ProInfo [subid]="'cmb_ProInfo'"
              [(ngModel)]="kymw6802Model.proInfo" [codeDiv]="'ctp109'" [initFocusItem]="cmb_ConvDiv"
              [reserve1]="cmb_ProDiv.selectedCodeValue" [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-promotion-code-combo-box>
          </div>

          <label class="list-input-title">催事</label>
          <div class="list-input-content">
            <input type="text" id="txti_ExhibitionDiv" #txti_ExhibitionDiv [(ngModel)]="kymw6802Model.exhibitionDiv"
              plessInputTextSub [maxlength]="8" [restrict]="'[0-9]'" forcedEnabledMode="true" [tabindex]="0">
          </div>

          <label class="list-input-title">タグ１</label>
          <div class="list-input-content">
            <app-kymw68-tag-combo-box id="cmb_Tag1" #cmb_Tag1 [subid]="'cmb_Tag1'" [width]="344" [forcedEnabledMode]="'true'"
              [tabindex]="0" [initFocusItem]="cmb_ConvDiv" [(ngModel)]="kymw6802Model.tag1">
            </app-kymw68-tag-combo-box>
          </div>

          <label class="list-input-title">タグ２</label>
          <div class="list-input-content">
            <app-kymw68-tag-combo-box id="cmb_Tag2" #cmb_Tag2 [subid]="'cmb_Tag2'" [width]="344" [forcedEnabledMode]="'true'"
              [tabindex]="0" [initFocusItem]="cmb_ConvDiv" [(ngModel)]="kymw6802Model.tag2">
            </app-kymw68-tag-combo-box>
          </div>

        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_Output" (click)="eventCSVOut_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>